<template>
	<div class="absolute inset-0 -z-10 overflow-hidden">
		<div class="absolute inset-0 bg-gradient-hero" />

		<NuxtImg
			src="/cdn/bubble_mobile.webp"
			class="block sm:hidden object-cover object-left-top sm:object-top absolute inset-0 w-full h-full pointer-events-none select-none"
			format="webp"
			densities="1x 2x"
			loading="eager"
			fetchpriority="high"
			decoding="async"
			alt="Bubble"
		/>

		<NuxtImg
			src="/cdn/bubble.webp"
			class="hidden sm:block object-cover object-left-top sm:object-top absolute inset-0 w-full h-full pointer-events-none select-none"
			format="webp"
			densities="1x 2x"
			loading="eager"
			fetchpriority="high"
			decoding="async"
			alt="Bubble"
		/>

		<div class="absolute top-0 left-0 hidden lg:block h-full">
			<div class="relative w-80 h-96 opacity-60 2xl:opacity-100 overflow-hidden">
				<NuxtImg
					src="/cdn/clover_1.webp"
					class="absolute inset-0 w-full h-full object-cover object-top"
					alt="Clover left"
				/>
			</div>

			<div class="absolute top-52 left-10 w-28 aspect-square animation-bottom">
				<NuxtPicture
					src="/cdn/ball_6.webp"
					format="webp"
					:img-attrs="{
						alt: 'Ball 6',
						width: 110,
						height: 110,
						loading: 'eager',
						class: 'block w-full h-full object-contain pointer-events-none select-none',
					}"
					:modifiers="{ height: undefined, fit: 'contain' }"
				/>
			</div>
		</div>

		<div class="absolute top-0 right-0 hidden lg:block h-full">
			<div class="relative w-96 h-[700px] overflow-hidden opacity-60 2xl:opacity-100">
				<NuxtImg
					src="/cdn/clover_2.webp"
					class="absolute inset-0 w-full h-full object-cover object-center"
					alt="Clover right"
				/>
			</div>

			<NuxtImg
				src="/cdn/ball_3.webp"
				alt="Ball 3"
				width="110"
				height="110"
				loading="eager"
				class="size-12 object-contain aspect-square absolute top-20 -right-7 animation-top"
			/>

			<div class="absolute w-20 top-24 right-40 animation-top">
				<NuxtPicture
					src="/cdn/ball_5.webp"
					format="webp"
					:img-attrs="{
						alt: 'Ball 5',
						width: 110,
						height: 110,
						loading: 'eager',
						class: 'block w-full h-full object-contain pointer-events-none select-none',
					}"
					:modifiers="{ height: undefined, fit: 'contain' }"
				/>
			</div>

			<NuxtImg
				src="/cdn/ball_4.webp"
				alt="Ball 4"
				width="110"
				height="110"
				loading="eager"
				class="size-14 object-contain aspect-square absolute top-[32rem] right-72 animation-bottom"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
defineOptions({
	name: 'BackgroundHero',
})
</script>

<style>
.animation-bottom-min {
	animation: ball-3 15s ease-in-out alternate infinite;
}

.animation-bottom {
	animation: ball-1 15s ease-in-out alternate infinite;
}

.animation-top {
	animation: ball-2 15s ease-in-out alternate infinite;
}

@keyframes ball-1 {
	0% {
		transform: translateY(0) scale(0.8);
	}
	50% {
		transform: translateY(300%) scale(1);
	}
	100% {
		transform: translateY(0) scale(0.8);
	}
}

@keyframes ball-2 {
	0% {
		transform: translateY(0) scale(0.8);
	}
	50% {
		transform: translateY(-100%) scale(1);
	}
	100% {
		transform: translateY(0) scale(0.8);
	}
}

@keyframes ball-3 {
	0% {
		transform: translateY(0) scale(0.8);
	}
	50% {
		transform: translateY(100%) scale(1);
	}
	100% {
		transform: translateY(0) scale(0.8);
	}
}

.bg-gradient-hero {
	background: linear-gradient(180deg, #4dd853 -3.07%, #233034 278.18%);
}
</style>
